import { render } from "./PersonRoleChangeStateForm.vue?vue&type=template&id=05de1be4"
import script from "./PersonRoleChangeStateForm.vue?vue&type=script&lang=js"
export * from "./PersonRoleChangeStateForm.vue?vue&type=script&lang=js"

import "./PersonRoleChangeStateForm.vue?vue&type=style&index=0&id=05de1be4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__